import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { TradeStrategies } from "../../assets/interfaces/interfaces";

export const getContractType = (leg) => {
  return (
    <>
      {leg.put_call === TradeStrategies.Call ? "Call" : "Put"}
      {" "}
      $
      {leg.strike_price}
      <br />
      {leg.expiry_date}
    </>
  );
};
// sharing the first 3 cells in the table - this component should receive order so that mapping takes place in parent component
const SharedTableContent = ({ order, hasLegs }) => {
  const { trades } = useSelector((state: { tradeOrders }) => state.tradeOrders);

  const findTradeByOrderId = (orderId) => {
    const trade = trades.find(trade => trade.order_id === orderId);
    return trade.trade_idea[0].trade_idea;
  };

  const associatedTrade = findTradeByOrderId(order.external_order_id);
  return (

    <React.Fragment>
      <TableCell>
        <>
          <div className="caption">
            {hasLegs ? "Multi Leg • " : "Single Leg • "}
            {associatedTrade?.symbol}
          </div>
          <div className="body2">{associatedTrade?.option_strategy}</div>
        </>
      </TableCell>
      <TableCell>
        <TableCell>
          {(hasLegs ? associatedTrade.legs : [associatedTrade.legs[0] || {}]).map((leg, index) => (
            <TableRow key={`leg-${order.id}-${index}`}>
              <TableCell className="nested-row">{getContractType(leg)}</TableCell>
            </TableRow>
          ))}
        </TableCell>
      </TableCell>
    </React.Fragment>
  );
};

export default SharedTableContent;
